import type { Locale as DateFnsLocale } from "date-fns";
import { enUS, ja, ko, zhCN, zhTW } from "date-fns/locale";
import { isLocale, type Locale } from "@/i18n/routing";

/**
 * 앱 locale → date-fns locale 단일 표.
 * `Record<Locale, …>` 라서 routing 의 `locales`에 언어를 추가하면 여기서 컴파일 에러가 난다.
 */
const DATE_FNS_LOCALES: Record<Locale, DateFnsLocale> = {
  ko,
  en: enUS,
  ja,
  "zh-CN": zhCN,
  "zh-TW": zhTW,
};

/** 지원하지 않는 값이 들어오면 enUS. */
export function getDateFnsLocale(locale: string): DateFnsLocale {
  return isLocale(locale) ? DATE_FNS_LOCALES[locale] : enUS;
}
